import { createTheme, ThemeOptions } from '@mui/material/styles'
import { NimbraBlueLight, NimbraGreyLight } from 'common-ui/themes/palettes'
import { defaultCommon } from 'common-ui/themes/common'

const billingLightOptions: ThemeOptions = {
    palette: {
        mode: 'light',
        background: {
            default: '#F5F5F5',
        },
        primary: {
            main: NimbraBlueLight[500],
            light: NimbraBlueLight[300],
            dark: NimbraBlueLight[900],
        },
        secondary: {
            main: NimbraBlueLight[400],
            light: NimbraBlueLight[200],
            dark: NimbraBlueLight[800],
        },
        success: {
            main: '#379d8c',
            dark: '#739f94',
            light: '#67E2BF',
        },
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                },
                colorPrimary: {
                    backgroundColor: '#f1e8e8',
                    color: '#757575',
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                regular: {
                    backgroundColor: 'transparent' as const,
                    color: '#000000',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: `1px solid ${NimbraGreyLight[400]}`,
                },
                head: {
                    backgroundColor: NimbraGreyLight[200],
                },
            },
        },
    },
}

export const billingThemeLight = createTheme({
    ...defaultCommon,
    ...billingLightOptions,
    palette: { ...defaultCommon.palette, ...billingLightOptions.palette },
    components: { ...defaultCommon.components, ...billingLightOptions.components },
})
